/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { BPay } from "./BPay";
import * as t from "io-ts";

// required attributes
const RestBPayResponseR = t.interface({});

// optional attributes
const RestBPayResponseO = t.partial({
  data: t.readonlyArray(BPay, "array of BPay")
});

export const RestBPayResponse = t.intersection(
  [RestBPayResponseR, RestBPayResponseO],
  "RestBPayResponse"
);

export type RestBPayResponse = t.TypeOf<typeof RestBPayResponse>;
